import { Button, Center, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import VisaTransactionStatusDatatableRowMeta from "@Modules/interfaceManagement/visaBase2/containers/tableHandlers/transaction/visaTransactionStatus/VisaTransactionStatusDatatableRowMeta";
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';
import { CustomButton } from '@Modules/core/components';

export type TVisaTransactionStatusDataTableData = {
    primaryKey: string | number,
    date: string,
    acquirerReference: string,
    acquirerBIN: string,
    merchant: string,
    accountNumber: string,
    amount: string,
    currency: string,
    authorization: string,
    pres1: string,
    reversal1: string,
    firstCharge: string,
    reversal2: string,
    pres2: string,
    reversal3: string,
    
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
  displayDetails: (row: any) => void,
};

const columnHelper = createColumnHelper<TVisaTransactionStatusDataTableData>()

export function getVisaTransactionStatusDataTableColumns({ isLoading, handleEdit, displayDetails }: Props) {
  
  return [
    columnHelper.accessor("date",
        {
            id: "date",
            header: "Date",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("acquirerReference",
        {
            id: "acquirerReference",
            header: "N° Ref: acquereur",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("acquirerBIN",
        {
            id: "acquirerBIN",
            header: "BIN acquereur",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("merchant",
        {
            id: "merchant",
            header: "Commercant",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("accountNumber", 
        {
            id: "accountNumber",
            header: "N° Compte",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("amount",
        {
            id: "amount",
            header: "Montant",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("currency",
        {
            id: "currency",
            header: "Devise",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("authorization",
        {
            id: "authorization",
            header: "Autorisation",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("pres1",
        {
            id: "pres1",
            header: "Pres.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),
    columnHelper.accessor("reversal1",
        {
            id: "reversal1",
            header: "Reversal",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),
    columnHelper.accessor("firstCharge",
        {
            id: "firstCharge",
            header: "1st Charg.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),
    columnHelper.accessor("reversal2",
        {
            id: "reversal2",
            header: "Reversal",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),    
    columnHelper.accessor("pres2",
        {
            id: "pres2",
            header: "Pres.",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),
    columnHelper.accessor("reversal3",
        {
            id: "reversal3",
            header: "Reversal",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),
    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center display={'flex'} gap={5}>
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}                            
                        >
                            Edit
                        </CustomButton>
                        <CustomDataTableInfoBtn disabled={isLoading} onClick={() => displayDetails(props.row)} />
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
